export const createArticleCardRendering = (articlePage = true) => {
    const removeLink = (string) => {
        if( string )
            return string.replace(/<[^>]*>?/gm, "");
    }

    const renderImage = (articlePage, articleImage) => {
        if (articleImage.src !== null) {
            return `<div class="card-image">
                        <picture>
                            <source media="(min-width: 680px)" 
                                    srcset="${articlePage.imgSrc310} 1x, 
                                            ${articlePage.imgSrc620}  2x">

                            <source media="(max-width: 679)" 
                                    srcset="${articlePage.imgSrc659} 1x, 
                                            ${articlePage.imgSrc1318} 2x">

                            <img srcset="${articlePage.imgSrc310} 310w,
                                        ${articlePage.imgSrc659} 659w"
                                 src="${articleImage.src}" 
                                 type="image/*"
                                 alt="${articleImage.alt}" />
                        </picture>
                    </div>`;
        }
        return ``;
    }

    if (articlePage.article.image !== null) {
        const articleImage = articlePage.article.image;
        return `
            <li class="card standard-card card-single ${articleImage.src !== null ? 'image' : ''}">
                <a href="${articlePage.url}">
                    <div class="card-content">
                            ${renderImage(articlePage, articleImage)}
                        <div class="card-wrap">
                            <header class="card-header">
                               <h2>${articlePage.article.title}</h2>
                            </header>
                            <div class="card-body">
                                ${removeLink(articlePage.article.ingress)}
                            </div>
                        </div>
                    </div>
                </a>
            </li>
        `;
    }

    return `
        <li class="card standard-card card-single">
            <a href="${articlePage.url}">
                <div class="card-content">
                    <div class="card-wrap">
                        <header class="card-header">
                           <h2>${articlePage.article.title}</h2>
                        </header>
                        <div class="card-body">
                            ${removeLink(articlePage.article.ingress)}
                        </div>
                    </div>
                </div>
            </a>
        </li>
    `;
};